import React, { Component } from "react";

export default class RoomRugFilterMobileBrands extends Component {
  handleManualScroll = (direction) => {
    switch (direction) {
      case "right":
        document.getElementById("ulSlider").scrollLeft -= 120;
        break;
      default:
        document.getElementById("ulSlider").scrollLeft += 120;
        break;
    }
  };

  render() {
    return (
      <ul id="three-child-body active">
        {this.props.brands.map((brand) => (
          <li
            className={
              this.props.selectedBrands.indexOf(brand.id) >= 0
                ? "three-child active"
                : "three-child"
            }
            key={"filterBrandMobile" + brand.id + brand.name}
            onClick={() =>
              this.props.selectHandler(brand.id, this.props.activeFilter)
            }
          >
            <span>{brand.name}</span>
          </li>
        ))}
      </ul>
    );
  }
}
